import { MAX_FILE_SIZE } from './file-upload';

export class SupportTicketConstants {
  public static readonly MAX_FILE_SIZE = MAX_FILE_SIZE;

  public static readonly SUPPORTED_FILE_TYPES: { [mimeType: string]: string } = {
    "application/pdf": "picture_as_pdf",
    "image/gif": "image",
    "image/tiff": "image",
    "image/x-dcx": "image",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "description",
    "application/msword": "description",
    "image/jpeg": "image",
    "image/bmp": "image",
    "image/png": "image",
    "image/heic": "image",
    "text/html": "article",
    "text/plain": "article",
    "application/xml": "article",
    "text/xml": "article",
  };

  public static readonly PREVIEWABLE_MEDIA_TYPES = new Set<string>([
    "application/pdf",
    "image/jpeg",
    "image/png",
    "image/gif",
    "image/bmp",
    "text/plain",
    "text/html",
    "application/xml",
    "text/xml",
  ]);

  public static readonly DOCUMENT_TYPES = [
    "Clinical Note",
    "Procedure Report",
    "Sleep Study",
    "Audiogram",
    "Imaging CT",
    "Imaging MRI",
    "Imaging Ultrasound",
    "Imaging FNA",
    "Patient Plan",
    "Referral",
    "Lab Results",
    "PROM",
    "Other",
  ] as const;

  public static readonly FILE_ACCEPT =
    ".pdf,.gif,.tif,.tiff,.dcx,.doc,.docx,.jpeg,.jpg,.bmp,.png,.heic,.htm,.html,.txt,.xml";
}
